var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "image-preview-component ImagePreview",
      class: { inProgress: _vm.inProgress }
    },
    [
      _c("CoverImg", { attrs: { src: _vm.imgURL, height_ratio: 1 } }, [
        _c("div", { staticClass: "item-content" }, [
          _c(
            "div",
            { staticClass: "text-right" },
            [_c("DeleteBtn", { on: { click: _vm.deleteImage } })],
            1
          ),
          _vm._v(" "),
          _vm.inProgress
            ? _c("div", { staticClass: "text-center progress-status" }, [
                _vm.image.upload_percentage
                  ? _c("span", [
                      _vm._v(_vm._s(_vm.image.upload_percentage) + "%")
                    ])
                  : _c("span", { staticClass: "spinner-border" })
              ])
            : _vm._e()
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }